import ToggleListItem from '@components/ToggleListItem'

interface NotificationItemProps {
  callbacks: {
    updateNotificationOptions: (key: string) => void,
  },
  disabledNotifications: string[],
  toggleItem: {
    key: string,
    title: string,
    user_types: string[],
    is_enabled?: boolean,
  },
  isBrandCustomProfile?: boolean,
  systemDefaultEnabled?: boolean,
}

export interface ToggleItem {
    key: string,
    title: string,
    user_types: string[],
}

const NotificationItem = (props: NotificationItemProps) => {
  const {
    callbacks, disabledNotifications, toggleItem, isBrandCustomProfile, systemDefaultEnabled,
  } = props

  const { key, title, is_enabled } = toggleItem

  const { updateNotificationOptions } = callbacks

  const enabled = !disabledNotifications.includes(key)

  return (
    <ToggleListItem
      onClick={() => ((isBrandCustomProfile || systemDefaultEnabled) ? undefined : updateNotificationOptions(key))}
      toggleValue={is_enabled !== undefined ? is_enabled : enabled}
      boxProps={{
        opacity: (systemDefaultEnabled || isBrandCustomProfile) ? 0.5 : 1,
      }}
    >
      <ToggleListItem.Title>{title}</ToggleListItem.Title>
    </ToggleListItem>
  )
}

export default NotificationItem
